import axios from 'axios';
import loginService from '../service/login';

const fileDownload = require('js-file-download');

export const getPatient = async (url) => {
  if (!loginService.getToken()) {
    return;
  }
  const config = {
    headers: {
      accept: 'application/json',
      Authorization: `Bearer `,
      // Authorization: `Bearer ${loginService.getToken()}`,
      Pragma: 'no-cache',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type',
    },
  };
  const response = await axios
    .get(url, config)
    .then(function(res) {
      return { status: res.status, data: res };
    })
    .catch(function(error) {
      if (error && error.response) {
        return error.response;
      } else {
        return error;
      }
    });

  return response;
};

export const get = async (url) => {
  if (!loginService.getToken()) {
    return;
  }
  const config = {
    headers: {
      accept: 'application/json',
      Authorization: `Bearer `,
      Pragma: 'no-cache',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type',
    },
  };
  const response = await axios
    .get(url, config)
    .then(function(res) {
      return { status: res.status, data: res };
    })
    .catch(function(error) {
      if (error && error.response) {
        return error.response;
      } else {
        return error;
      }
    });

  return response;
};

export const remove = async (url) => {
  if (!loginService.getToken()) {
    return;
  }
  const config = {
    headers: {
      accept: 'application/json',
      Authorization: `Bearer `,
      Pragma: 'no-cache',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type',
    },
  };
  const response = await axios
    .delete(url, config)
    .then(function(res) {
      return { status: res.status, data: res };
    })
    .catch(function(error) {
      if (error && error.response) {
        return error.response;
      } else {
        return error;
      }
    });

  return response;
};

export const post = async (url, data) => {
  if (!loginService.getToken()) {
    return;
  }
  const config = {
    headers: {
      accept: 'application/json',
      Authorization: `Bearer `,
      Pragma: 'no-cache',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type',
    },
  };
  const response = await axios
    .post(url, data, config)
    .then(function(res) {
      return { status: res.status, data: res };
    })
    .catch(function(error) {
      if (error && error.response) {
        return error.response;
      } else {
        return error;
      }
    });

  return response;
};

export const upload = async (url, data, cb) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
      Pragma: 'no-cache',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type',
    },
    onUploadProgress: function(progressEvent) {
      var percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      cb(percentCompleted);
    },
  };
  const response = await axios
    .post(url, data, config)
    .then(function(res) {
      return { status: res.status, data: res };
    })
    .catch(function(error) {
      if (error && error.response) {
        return error.response;
      } else {
        return error;
      }
    });

  return response;
};

export const download = async (url, filename) => {
  if (!loginService.getToken()) {
    return;
  }
  const config = {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer `,
      Pragma: 'no-cache',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type',
    },
  };

  const response = await axios
    .get(url, config)
    .then(function(res) {
      fileDownload(res.data, filename);
      return { status: res.status };
    })
    .catch(function(error) {
      if (error && error.response) {
        return error.response;
      } else {
        return error;
      }
    });
  return response;
};

export const put = async (url, data) => {
  if (!loginService.getToken()) {
    return;
  }
  const config = {
    headers: {
      accept: 'application/json',
      Authorization: `Bearer `,
      Pragma: 'no-cache',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type',
    },
  };
  const response = await axios
    .put(url, data, config)
    .then(function(res) {
      return { status: res.status, data: res };
    })
    .catch(function(error) {
      if (error && error.response) {
        return error.response;
      } else {
        return error;
      }
    });

  return response;
};
